if (!customElements.get('popup-form-widget')) {
  customElements.define(
    'popup-form-widget',
    class PopupFormWidget extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-open-popup-form-widget']);
      }

      constructor() {
        super();
        this.isOpened = false;
        this.boundClickHandler = null;
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.openPopupFormWidget;
        this.modalId = this.id;
        this.blockId = this.dataset.blockId;

        window.FoxTheme.DOMready(this.init.bind(this));
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        
        if (this.boundClickHandler) {
          document.removeEventListener('click', this.boundClickHandler);
        }
      }

      init() {
        this.showDefaultForm();
        this.setupButtonTriggers();

        if (this.triggerOpen === 'delay' && !Shopify.designMode) {
          this.handleDelayTrigger();
        }
      }

      hideAllForms() {
        const allForms = this.querySelectorAll('.popup-form-widget__form-block');
        allForms.forEach(form => form.style.display = 'none');
      }

      setupButtonTriggers() {
        this.boundClickHandler = (e) => {
          const trigger = e.target.closest('[data-popup-form-trigger]');
          if (!trigger) return;

          const formKey = trigger.getAttribute('data-form-key');
          const targetModalId = trigger.getAttribute('data-target-modal');
          const isTargetingThis = !targetModalId || 
                                  targetModalId === this.modalId || 
                                  targetModalId === this.blockId;
          
          if (!isTargetingThis) return;
          
          if (!formKey) {
            return;
          }

          const matchingForm = this.querySelector(`[data-form-key="${formKey}"]`);
          if (!matchingForm) {
            return;
          }

          e.preventDefault();
          
          this.switchForm(formKey);
          this.show();
        };

        document.addEventListener('click', this.boundClickHandler);
      }

      handleDelayTrigger() {
        if (this.isOpened) return;
        
        setTimeout(() => {
          this.showDefaultForm();
          this.show();
        }, 5000);
      }

      switchForm(formKey) {
        const allForms = this.querySelectorAll('.popup-form-widget__form-block');
        let formFound = false;
        
        allForms.forEach(form => {
          if (form.dataset.formKey === formKey) {
            form.style.display = 'block';
            formFound = true;
          } else {
            form.style.display = 'none';
          }
        });
        
        if (!formFound) {
          console.log(`Form with key "${formKey}" not found in popup ${this.modalId}. Showing default form.`);
          this.showDefaultForm();
        }
      }

      showDefaultForm() {
        const allForms = this.querySelectorAll('.popup-form-widget__form-block');
        
        allForms.forEach(form => form.style.display = 'none');
        
        if (allForms.length > 0) {
          allForms[0].style.display = 'block';
        }
      }

      prepareToShow() {
        super.prepareToShow();
        this.isOpened = true;
      }
    }
  );
}